import shared_messages_en from '../../../../../_themes/centralOnlineTheme/src/main/js/i18n/en/messages_en.mjs';
import messages_en from './en/messages_en.mjs';

export default {
  en: {
    ...shared_messages_en,
    ...messages_en,
  },
};
